import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

export const getAwpFeatureFlags = async () => {
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.AWP_RENDERER,
  });
  return {
    featureFlags: {
      featureFlagLogo: featureFlagLogo ?? null,
    },
  };
};
